import { motion } from 'framer-motion';
import { fadeUp, staggeredFadeIn } from '../../utils/animations';

const leverageColumns = [
    {
        label: 'Admin',
        headerBg: 'bg-[#2A9D8F]',
        tasks: ['Listing manager & TC', 'Text threads', 'Writing offers', 'Showing feedback', 'Scheduling showings', 'Weekly seller reports', 'Email management', 'File management', 'Book travel'],
    },
    {
        label: 'Marketing',
        headerBg: 'bg-[#E76F51]',
        tasks: ['Email newsletter', 'Social media', 'Events', 'Direct mail', 'Anniversary cards', 'CRM management', 'Operations manual', 'Referral marketing'],
    },
    {
        label: 'Other Roles',
        headerBg: 'bg-[#1B3A5C]',
        tasks: ['Monitor agent referral groups', 'Video editor', 'AEO / SEO', 'Membership site', 'Brokerage onboarding'],
    },
];

export function VALeverage() {
    return (
        <section className="bg-navy-900 py-24 md:py-32" data-testid="va-leverage">
            <div className="max-w-5xl mx-auto px-6 lg:px-12">
                <motion.div {...fadeUp} className="text-center mb-14">
                    <h2 className="font-montserrat font-bold text-3xl md:text-4xl text-white tracking-tight">
                        Adam's VA Leverage
                    </h2>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {leverageColumns.map((col, ci) => (
                        <motion.div
                            key={col.label}
                            {...staggeredFadeIn(ci * 0.1)}
                            data-testid={`leverage-col-${ci}`}
                        >
                            <div className={`${col.headerBg} rounded-full px-5 py-3 text-center mb-4`}>
                                <span className="text-white font-montserrat font-bold text-sm">{col.label}</span>
                            </div>
                            <div className="space-y-2">
                                {col.tasks.map((task) => (
                                    <div key={task} className="bg-white/5 border border-white/15 rounded-full px-5 py-2.5 text-center">
                                        <span className="text-gray-300 text-sm">{task}</span>
                                    </div>
                                ))}
                            </div>
                        </motion.div>
                    ))}
                </div>

                <motion.p {...fadeUp} className="text-center text-gray-400 text-sm mt-12 italic">
                    Three VAs. One lean operation. ~35 hours a week.
                </motion.p>
            </div>
        </section>
    );
}
